// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__D4DZP","l12":"Loader_l12__dDN-8","full-screen":"Loader_full-screen__Y8Ryh"};